import { DwellLoggerType } from './DwellLoggerType';
import FDPDwellLogger from './FDPDwellLogger';
var DwellLoggerFactory = /** @class */ (function () {
    function DwellLoggerFactory(loggerType) {
        this._dwellLogger = this.getDwellLogger(loggerType);
    }
    DwellLoggerFactory.prototype.logDwellInfo = function (dwellObject) {
        var _a;
        var dwellTime = dwellObject.endTime - dwellObject.startTime - dwellObject.inactivityTime;
        if (isFinite(dwellTime) && dwellTime > 0) {
            (_a = this._dwellLogger) === null || _a === void 0 ? void 0 : _a.logDwellInfo(dwellObject, dwellTime);
        }
    };
    DwellLoggerFactory.prototype.getDwellLogger = function (loggerType) {
        switch (loggerType) {
            case DwellLoggerType.FDP:
                return new FDPDwellLogger();
            default:
                return undefined;
        }
    };
    return DwellLoggerFactory;
}());
export { DwellLoggerFactory };
